export default "__VITE_ASSET__Cg6dWux1__"